import { FieldDefinition } from "./fieldDefinitions";

export interface MedicineDto {
  medicineId: number;
  name: string;
  company?: string;
  activeIngredient?: string;
  remarks?: string;
  active: boolean;
  userIdInserted: number;
  dateInserted: string;
}
export const medecineKeyId = "medicineId" as const;

export const medicineFields: FieldDefinition[] = [
  { name: "name", label: "Όνομα Φαρμάκου", type: "text", required: true },
  { name: "company", label: "Εταιρεία", type: "text", required: false },
  {
    name: "activeIngredient",
    label: "Δραστική Ουσία",
    type: "text",
    required: false,
  },
  { name: "remarks", label: "Παρατηρήσεις", type: "text", required: false },
  { name: "active", label: "Ενεργό", type: "checkbox", required: true },
  {
    name: "userIdInserted",
    label: "ID Χρήστη Εισαγωγής",
    type: "number",
    required: true,
  },
  {
    name: "dateInserted",
    label: "Ημερομηνία Εισαγωγής",
    type: "date",
    required: true,
  },
] as const;

export const medicineFilters = medicineFields.filter((f) =>
  ["name", "company", "activeIngredient", "remarks"].includes(f.name),
);

export const medicineFormData: string[] = [
  "name",
  "company",
  "activeIngredient",
  "remarks",
];
